export const WELLBORE_FILE_ACTIONS = {
  UPDATE_WELLBORE_FILE: 'UPDATE_WELLBORE_FILE',
  UPLOAD_WELLBORE_FILE: 'UPLOAD_WELLBORE_FILE',
  DELETE_WELLBORE_FILE: 'DELETE_WELLBORE_FILE',
  RECEIVE_WELLBORE_FILE: 'RECEIVE_WELLBORE_FILE',
  RECEIVE_WELLBORE_FILES: 'RECEIVE_WELLBORE_FILES',
  DOWNLOAD_WELLBORE_FILE: 'DOWNLOAD_WELLBORE_FILE',
  UPLOAD_FILE_MODAL_UNLOADED: 'UPLOAD_FILE_MODAL_UNLOADED',
  SET_DOCUMENT_CATEGORY_FILTER: 'SET_DOCUMENT_CATEGORY_FILTER',
  WELLBORE_FILES_PAGE_LOADED: 'WELLBORE_FILES_PAGE_LOADED',
  WELLBORE_FILES_PAGE_UNLOADED: 'WELLBORE_FILES_PAGE_UNLOADED',
};

export const WELLBORE_FILE_CATEGORY = {
  UNKNOWN: 1,
  HISTORY: 2,
  TALLY: 3,
  SURVEY: 4,
  PROGRAM: 5,
  COMPLETION: 6,
  BHA: 7,
  OTHER: 8,
  RIG_UP: 9,
  DECK_LAYOUT: 10,
  SIMULATION: 11,
  RISK: 12,
  FIELD: 13,
  FACILITY: 14,
  INTERNAL: 15,
  CHECKLISTS: 16,
  PROCEDURES: 17,
  LOG_REPORT: 18,
  INTEGRITY: 19,
  CORROSION: 20,
};